import {Ref} from 'react';
import {type SelectInstance} from 'react-select';

import {Nullish} from 'shared/web';

import {OptionTypeBase} from '../../../types/OptionTypeBase';

export function selectMultiOption<ValueType>(
  select: SelectInstance<OptionTypeBase<ValueType | Nullish>, true>
) {
  // eslint-disable-next-line eslint-js/no-restricted-syntax
  const menuRef: Ref<HTMLDivElement> = select?.menuListRef as unknown as Ref<HTMLDivElement>;
  if (!menuRef) {
    return;
  }
  if (typeof menuRef !== 'object') {
    return;
  }

  const menu = menuRef.current;
  if (!menu) {
    return;
  }
  if (!menu.querySelector) {
    return;
  }

  const selectedOption: HTMLElement | null = menu.querySelector('*[data-selected="true"]');
  if (!selectedOption) {
    return;
  }

  selectedOption.focus();
}
